<script>
	import formBase from '@_system/components/base/form.vue'
	import goodsbox from './box/goods.vue'
	export default {
		extends: formBase,
		name: 'exchangeorderForm',
		render(h) {
			this.$slots.plug = [
				<goodsbox ref = "goodsbox" onSubmit={this.goodsboxSubmit} />,
			]
			return formBase.render.call(this, h)
		},
		props: {

		},
		data() {
			return {
				tableHandle:{},
				sourcedata:{},
				reasondetail:[],
				autoapply:5,
				isReady:true
			}

		},

		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			afterSave(e){
				if(this.autoapply==5){
					this.$message.success('正在打开付款申请表....')
					this.$api.exchangeorder.getexchangebyid({id:e}).then((res)=>{
						if(res){
							this.apply({
								exchange_no:res.exchangecode,
							})
						}
					})
				}
			},
			apply(row){
				this.$api.flow.getSingleFlowTemplate(20).then((e) => {
					if (e) {
						let res = this.$router.resolve({
							name: 'add',
							query: {
								name: 'paymentapplication',								
								id: 0,
								controlltype: 1,
								windowName: '售后付款申请',
								extra: JSON.stringify({
									billCode: row.exchange_no,
									componentname:'exchangepaymentform',
									// receiveaccount:row.receive_account,
								}),
								isflow: 1,
								flowid: 20
							}
						})
						if (this.device != 'pc') {
							this.$router.push(res.href.replace(/#/g, ''))
						} else {
							let win = window.open(res.href, this.moduleName + "add",
								this.$store.state.system.windowConfig)
							win.onload = () => {
								console.log(this.moduleName + 'form open')
							}
						}
							
					}
				})
			},
			beforeInit(next){
				if(this.id){
					this.isReady = false
				}
				// console.log(this.extra,111111111)
				this.$api.exchangeorder.getreasondetail().then((res) => {
					this.reasondetail = res
					next()
				})				
			},
			afterGet() {
				this.isReady = true
			},
			ready(){
				for(let i in this.extra){
					this.fApi.setValue(i,this.extra[i])
				}
				if(this.extra.ordercode){
					this.ordercodeButton()
				}
				
			},
			beforeSubmit(formData, resolve){
				// let type = this.fApi.getValue('type')
				// let amount = this.fApi.getValue('amount')
				let payer = this.fApi.getValue('payer')
				let payMoney = this.fApi.getValue('payMoney')
				let autoapply = this.fApi.getValue('autoapply')
				this.autoapply = autoapply
				let rcvAcc = this.fApi.getValue('rcvAcc')
				let rcvBankName = this.fApi.getValue('rcvBankName')
				let rcvName = this.fApi.getValue('rcvName')
				let file_img = this.fApi.getValue('file_img')
				
				// if(type == 4 && !payer && payMoney==0 && amount == 0 && !this.id) {
				// 	this.$message.error('售后类型仅退款【赔付方】【赔付金额】【退款金额】必填')
				// 	return
				// }
				
				
				if(payMoney!=0 && !payer){
					this.$message.error('赔付金额不为0【赔付方】不能为空')
					return
				}
				let file_img_exist = Array.isArray(file_img)?file_img.length:file_img
				if(autoapply == 5 && (!rcvAcc || !rcvName || ! file_img_exist   )){
					this.$message.error('自动发起付款申请【收款账户】【收款人/公司】【凭证】不能为空')
					return
				}
				
				let param = {}
				let $son_exchangeorder_goods = this.fApi.el('$son_exchangeorder_goods')
				let goods = $son_exchangeorder_goods.getGrid().getTableData().tableData
				
				let $son_exchangeorder_ingoods = this.fApi.el('$son_exchangeorder_ingoods')
				let ingoods = $son_exchangeorder_ingoods.getGrid().getTableData().tableData
				// console.log(this.sourcedata,'this.sourcedata')
				// this.sourcedata.orders = this.sourcedata.orders?this.sourcedata.orders:[],
				// this.sourcedata.outorders = this.sourcedata.outorders?this.sourcedata.outorders:[],
				// this.sourcedata.inorders = this.sourcedata.inorders?this.sourcedata.inorders:[]
				if( !this.sourcedata.orders &&  !this.sourcedata.outorders &&  !this.sourcedata.inorders){
					formData.trade_param = JSON.stringify(param)
					resolve()
					return
				}
				let orders = this.sourcedata.orders.map((item)=>{
					return item.param
				})
				let outorders = this.sourcedata.outorders.map((item)=>{
					return item.param
				})
				let inorders = this.sourcedata.inorders.map((item)=>{
					return item.param
				})
				outorders = goods.map((item)=>{
					item.param.tp_item_size = parseInt(item.num)
					item.param.tp_payment = parseFloat(item.amount)
					item.param.dividePrice = parseFloat(item.discountprice)
					item.param.discount_unit_price = parseFloat(item.discountprice)
					item.param.remark = item.mark
					return item.param
				})
				inorders = ingoods.map((item)=>{
					item.param.tp_item_size = parseInt(item.num)
					item.param.tp_payment = parseFloat(item.amount)
					item.param.dividePrice = parseFloat(item.discountprice)
					item.param.discount_unit_price = parseFloat(item.discountprice)
					item.param.remark = item.mark
					return item.param
				})
				
				
				param.trade = this.sourcedata.trade.trade_param
				param.orders = orders
				param.inorders = inorders
				param.outorders = outorders
				if(payMoney!=0){
					param.trade.payer = payer
					param.trade.payMoney = payMoney
				}
				if(autoapply == 5 ){
					if(rcvBankName){
						param.trade.receive_account = rcvAcc+'|'+rcvName+'|'+rcvBankName
					}else{
						param.trade.receive_account = rcvAcc+'|'+rcvName
					}
				}
				if(Array.isArray(file_img)){
					file_img.forEach((item,index)=>{
						param.trade['pic'+(index+1)] = item.path
					})
				}
				
				
				formData.trade_param = JSON.stringify(param)
				resolve()
			},
			resetdetail(type){
				// console.log(this.isReady)
				if(!this.isReady){
					return
				}
				let $son_exchangeorder_goods = this.fApi.el('$son_exchangeorder_goods')
				$son_exchangeorder_goods.getGrid().remove()
				let $son_exchangeorder_ingoods = this.fApi.el('$son_exchangeorder_ingoods')
				$son_exchangeorder_ingoods.getGrid().remove()
				if(this.sourcedata){
					if(type == 1){
						if(this.sourcedata.outorders){
							let outorders = JSON.parse(JSON.stringify(this.sourcedata.outorders))
							outorders.forEach((item)=>{
								item.discountprice = 0
								item.amount = 0
							})
							$son_exchangeorder_goods.getGrid().insertAt(outorders,-1)	
						}
					}else if(type == 2){
						$son_exchangeorder_goods.getGrid().insertAt(this.sourcedata.outorders,-1)	
						$son_exchangeorder_ingoods.getGrid().insertAt(this.sourcedata.inorders,-1)
					}else{
						$son_exchangeorder_ingoods.getGrid().insertAt(this.sourcedata.inorders,-1)
					}
				}
			},

			typeChange(){
				let type = this.fApi.getValue('type')
				// this.fApi.setValue('reasonid',null)
				// this.fApi.setValue('reasondetail',null)
				this.resetreasondetail()
				this.resetdetail(type)

				// this.reasonidChange(this.fApi.getValue('reasonid'))
			},
			reasonidChange(e){
				if(!e){
					this.fApi.setValue('reasondetail',null)
					return
				}
				let type = this.fApi.getValue('type')
				let reasondetail = this.reasondetail.find((item)=>{
					return item.emunvalueid == e
				})
				if(reasondetail.type){
					if(!type){
						// console.log(reasondetail.type,type)
						this.fApi.setValue('type',reasondetail.type)
						this.fApi.setValue('reasondetail',null)
						type = this.fApi.getValue('type')
					}
				}		
				
				this.resetreasondetail()
				this.resetdetail(type)
			},
			resetreasondetail(){
				if(!this.isReady){
					return
				}
				// console.log(this.id)
					let type = this.fApi.getValue('type')
					let reasonid = this.fApi.getValue('reasonid')
					let reasondetail = this.reasondetail.find((item)=>{
						return item.emunvalueid == reasonid
					})	
					if(reasondetail){
						if(type == 0){
							this.fApi.setValue('reasondetail',reasondetail.wln_reasondetail_tuihuo)												
						}
						if(type == 1){
							this.fApi.setValue('reasondetail',reasondetail.wln_reasondetail_bufa)												
						}
						if(type == 2){
							this.fApi.setValue('reasondetail',reasondetail.wln_reasondetail_huanhuo)												
						}
						if(type == 3){
							this.fApi.setValue('reasondetail',reasondetail.wln_reasondetail_qita)												
						}
						if(type == 4){
							this.fApi.setValue('reasondetail',reasondetail.wln_reasondetail_jintuikuan)
						}
						if(type == 5){
							this.fApi.setValue('reasondetail',reasondetail.wln_reasondetail_weixiu)
						}					
					}
			},
			ordercodeButton(){
				let tp_tid = this.fApi.getValue('ordercode')
				if(!tp_tid){
					this.$message.error('请输入订单号')
					return
				}
				this.loading = true
				this.$api.exchangeorder.listTrade({
					tp_tid:tp_tid
				}).then((res) => {
					this.sourcedata = res
					let city = []
					if(res.trade.tp_receiver_state){
						city.push(res.trade.tp_receiver_state)
					}
					if(res.trade.tp_receiver_city){
						city.push(res.trade.tp_receiver_city)
					}
					if(res.trade.tp_receiver_district){
						city.push(res.trade.tp_receiver_district)
					}
					city = window.systemMethods.getEmunId('city',city.join('/'))
					
					this.fApi.setValue('ordercode',res.trade.ordercode)
					this.fApi.setValue('tptid',res.trade.tptid)
					this.fApi.setValue('storeid',res.trade.storeid)
					this.fApi.setValue('nickname',res.trade.nickname)
					this.fApi.setValue('name',res.trade.name)
					this.fApi.setValue('phone',res.trade.phone)
					this.fApi.setValue('call',res.trade.call)
					this.fApi.setValue('zipcode',res.trade.zipcode)
					this.fApi.setValue('city',city)
					this.fApi.setValue('street',res.trade.street)
					this.fApi.setValue('address',res.trade.address)
					this.fApi.setValue('refund_express',res.trade.express_uid)
					this.fApi.setValue('source_express',res.trade.express_uid)
					this.fApi.setValue('tradeRemark',res.trade.trade_param.tp_memo?res.trade.trade_param.tp_memo:res.trade.trade_param.mark)
					this.typeChange()
					// let $son_exchangeorder_ingoods = this.fApi.el('$son_exchangeorder_ingoods')
					// $son_exchangeorder_ingoods.getGrid().remove()
					// $son_exchangeorder_ingoods.getGrid().insertAt(res.inorders,-1)	
					
					// let $son_exchangeorder_goods = this.fApi.el('$son_exchangeorder_goods')
					// $son_exchangeorder_goods.getGrid().remove()
					// $son_exchangeorder_goods.getGrid().insertAt(res.outorders,-1)		
					
					this.loading = false
				},()=>{
					this.loading = false
				})
			},
			tableAdd(e) {
				this.tableHandle = e
				this.$refs.goodsbox.initList()
				this.$refs.goodsbox.box.alertBox()					
			},
			tablefieldChange(e) {
				if(e.moduleName == 'exchangeorder_goods' || e.moduleName == 'exchangeorder_ingoods'){
					this.getItemAmount(e.data.column.field,e.moduleName)
				}
				
			},
			getItemAmount(e,moduleName){
				let $son_exchangeorder_goods = this.fApi.el('$son_exchangeorder_goods')
				if(moduleName == 'exchangeorder_ingoods'){
					$son_exchangeorder_goods = this.fApi.el('$son_exchangeorder_ingoods')
				}
				
				let data = $son_exchangeorder_goods.getGrid().getTableData().tableData
				data.forEach((item)=>{
					item.num = Math.max(item.num,1)
					if(e == 'discountprice' || e == 'num'){
						item.amount = (item.discountprice * item.num).toFixed(4)
						item.amount = Number(item.amount)
					}
					if(e == 'amount'){
						item.discountprice = (item.amount / item.num).toFixed(4)
						item.discountprice = Number(item.discountprice)
					}
				})
			},
			goodsboxSubmit(e){
				this.tableHandle.obj = e.data
				this.tableHandle.next()
			}
		},
		components: {

		}
	}
</script>
